import React from 'react'
import { Box, Stack } from '@mui/material'

import { ImageBlock } from '../../image-block'
import { HeaderBody, SPACING } from '../../typography'
import { AvatarStack } from '../../namebar'

export const RumbleItem = (props) => {
    const {
        image,
        children,
        winner = null,
        entries = [],
        eliminations = [],
        entered = [],
        backgroundColor = '',
        color = ''
    } = props
    return (
        <>
            <Stack direction='column'
                sx={{ color }}
                spacing={SPACING}>
                {image && <ImageBlock image={image}
                    backgroundColor={backgroundColor} />}
                <HeaderBody>{entries.length} entries - {eliminations.length} eliminatons - {entered.length} entered</HeaderBody>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}>
                    {winner && <AvatarStack collection={[winner]} height={100} width={100} />}
                    {entries && <AvatarStack collection={entries}
                        max={3} />}
                </Box>
            </Stack>
            {children}
        </>
    )
}
